import { create } from "zustand";

interface OverlayState {
  activeCount: number;
  registerOverlay: () => void;
  unregisterOverlay: () => void;
}

export const useOverlayStore = create<OverlayState>((set) => ({
  activeCount: 0,
  registerOverlay: () =>
    set((s) => ({ activeCount: s.activeCount + 1 })),
  unregisterOverlay: () =>
    set((s) => ({ activeCount: Math.max(0, s.activeCount - 1) })),
}));
